import React from "react";

export default function ClockIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={48}
            height={48}
            viewBox="0 0 512 512"
            fill="currentColor"
            {...props}
        >
            <path d="M347.216,301.211l-71.387-53.54V138.609a19.83,19.83,0,0,0-39.66,0V257.587a19.789,19.789,0,0,0,7.932,15.864l79.318,59.489a19.831,19.831,0,0,0,23.8-31.729Z" />
            <path d="M256,0C114.833,0,0,114.833,0,256S114.833,512,256,512,512,397.167,512,256,397.167,0,256,0Zm0,472.341C136.725,472.341,39.659,375.275,39.659,256S136.725,39.659,256,39.659c119.295,0,216.341,97.066,216.341,216.341S375.275,472.341,256,472.341Z" />
        </svg>
    );
}
